module.exports = __webpack_public_path__ + "static/img/iconbgc7.153ee322.png";